/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppDeliveryRouteImport } from './routes/_app/delivery'
import { Route as AppRecentRouteImport } from './routes/_app/recent'
import { Route as AuthLaunchRouteImport } from './routes/auth/launch'
import { Route as AppPurchaseIndexRouteImport } from './routes/_app/purchase/index'
import { Route as AppPurchaseResultReferenceRouteImport } from './routes/_app/purchase/result.$reference'
import { Route as AppSaleResultReferenceRouteImport } from './routes/_app/sale/result.$reference'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppDeliveryRoute = AppDeliveryRouteImport.update({
  id: '/delivery',
  path: '/delivery',
  getParentRoute: () => AppRoute,
} as any)
const AppRecentRoute = AppRecentRouteImport.update({
  id: '/recent',
  path: '/recent',
  getParentRoute: () => AppRoute,
} as any)
const AuthLaunchRoute = AuthLaunchRouteImport.update({
  id: '/auth/launch',
  path: '/auth/launch',
  getParentRoute: () => rootRouteImport,
} as any)
const AppPurchaseIndexRoute = AppPurchaseIndexRouteImport.update({
  id: '/purchase/',
  path: '/purchase/',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchaseResultReferenceRoute =
  AppPurchaseResultReferenceRouteImport.update({
    id: '/purchase/result/$reference',
    path: '/purchase/result/$reference',
    getParentRoute: () => AppRoute,
  } as any)
const AppSaleResultReferenceRoute = AppSaleResultReferenceRouteImport.update({
  id: '/sale/result/$reference',
  path: '/sale/result/$reference',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/delivery': typeof AppDeliveryRoute
  '/recent': typeof AppRecentRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/purchase/': typeof AppPurchaseIndexRoute
  '/purchase/result/$reference': typeof AppPurchaseResultReferenceRoute
  '/sale/result/$reference': typeof AppSaleResultReferenceRoute
}
export interface FileRoutesByTo {
  '/delivery': typeof AppDeliveryRoute
  '/recent': typeof AppRecentRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/': typeof AppIndexRoute
  '/purchase': typeof AppPurchaseIndexRoute
  '/purchase/result/$reference': typeof AppPurchaseResultReferenceRoute
  '/sale/result/$reference': typeof AppSaleResultReferenceRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/delivery': typeof AppDeliveryRoute
  '/_app/recent': typeof AppRecentRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/_app/': typeof AppIndexRoute
  '/_app/purchase/': typeof AppPurchaseIndexRoute
  '/_app/purchase/result/$reference': typeof AppPurchaseResultReferenceRoute
  '/_app/sale/result/$reference': typeof AppSaleResultReferenceRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/delivery'
    | '/recent'
    | '/auth/launch'
    | '/purchase/'
    | '/purchase/result/$reference'
    | '/sale/result/$reference'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/delivery'
    | '/recent'
    | '/auth/launch'
    | '/'
    | '/purchase'
    | '/purchase/result/$reference'
    | '/sale/result/$reference'
  id:
    | '__root__'
    | '/_app'
    | '/_app/delivery'
    | '/_app/recent'
    | '/auth/launch'
    | '/_app/'
    | '/_app/purchase/'
    | '/_app/purchase/result/$reference'
    | '/_app/sale/result/$reference'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthLaunchRoute: typeof AuthLaunchRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/delivery': {
      id: '/_app/delivery'
      path: '/delivery'
      fullPath: '/delivery'
      preLoaderRoute: typeof AppDeliveryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/recent': {
      id: '/_app/recent'
      path: '/recent'
      fullPath: '/recent'
      preLoaderRoute: typeof AppRecentRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/launch': {
      id: '/auth/launch'
      path: '/auth/launch'
      fullPath: '/auth/launch'
      preLoaderRoute: typeof AuthLaunchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/purchase/': {
      id: '/_app/purchase/'
      path: '/purchase'
      fullPath: '/purchase/'
      preLoaderRoute: typeof AppPurchaseIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchase/result/$reference': {
      id: '/_app/purchase/result/$reference'
      path: '/purchase/result/$reference'
      fullPath: '/purchase/result/$reference'
      preLoaderRoute: typeof AppPurchaseResultReferenceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sale/result/$reference': {
      id: '/_app/sale/result/$reference'
      path: '/sale/result/$reference'
      fullPath: '/sale/result/$reference'
      preLoaderRoute: typeof AppSaleResultReferenceRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppDeliveryRoute: typeof AppDeliveryRoute
  AppRecentRoute: typeof AppRecentRoute
  AppIndexRoute: typeof AppIndexRoute
  AppPurchaseIndexRoute: typeof AppPurchaseIndexRoute
  AppPurchaseResultReferenceRoute: typeof AppPurchaseResultReferenceRoute
  AppSaleResultReferenceRoute: typeof AppSaleResultReferenceRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppDeliveryRoute: AppDeliveryRoute,
  AppRecentRoute: AppRecentRoute,
  AppIndexRoute: AppIndexRoute,
  AppPurchaseIndexRoute: AppPurchaseIndexRoute,
  AppPurchaseResultReferenceRoute: AppPurchaseResultReferenceRoute,
  AppSaleResultReferenceRoute: AppSaleResultReferenceRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthLaunchRoute: AuthLaunchRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
